// Guardian AI Governable AI Workspace Service Protocol Definitions
//
// Workspace API for AI governance:
//   - AI system inventory and guided intake
//   - Risk classification and approval gate workflows
//   - Evidence file checklists with missing-control tracking
//   - Incident, appeal, and redress workflow records
//   - System card, board summary, and audit pack exports
//   - Tenant-scoped activity logs
//   - Subscription quota enforcement
//
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/governableai/governable_ai.proto (package guardianai.v1.governableai, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/governableai/governable_ai.proto.
 */
export const file_guardianai_v1_governableai_governable_ai: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.governableai.System
 */
export type System = Message<"guardianai.v1.governableai.System"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string created_by = 3;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string purpose = 6;
   */
  purpose: string;

  /**
   * @generated from field: string business_unit = 7;
   */
  businessUnit: string;

  /**
   * @generated from field: string owner_user_id = 8;
   */
  ownerUserId: string;

  /**
   * @generated from field: string owner_name = 9;
   */
  ownerName: string;

  /**
   * @generated from field: string vendor_name = 10;
   */
  vendorName: string;

  /**
   * draft, active, retired
   *
   * @generated from field: string deployment_status = 11;
   */
  deploymentStatus: string;

  /**
   * minimal, limited, high, critical, prohibited
   *
   * @generated from field: string risk_class = 12;
   */
  riskClass: string;

  /**
   * draft, conditioned, approved, blocked, retired
   *
   * @generated from field: string approval_status = 13;
   */
  approvalStatus: string;

  /**
   * e.g., "2026-07"
   *
   * @generated from field: string template_version = 14;
   */
  templateVersion: string;

  /**
   * JSONB — evidence control state per system
   *
   * @generated from field: string controls_json = 15;
   */
  controlsJson: string;

  /**
   * JSONB — flexible metadata
   *
   * @generated from field: string metadata_json = 16;
   */
  metadataJson: string;

  /**
   * @generated from field: int64 created_at = 17;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 18;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.System
 */
export type SystemJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string created_by = 3;
   */
  createdBy?: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy?: string;

  /**
   * @generated from field: string name = 5;
   */
  name?: string;

  /**
   * @generated from field: string purpose = 6;
   */
  purpose?: string;

  /**
   * @generated from field: string business_unit = 7;
   */
  businessUnit?: string;

  /**
   * @generated from field: string owner_user_id = 8;
   */
  ownerUserId?: string;

  /**
   * @generated from field: string owner_name = 9;
   */
  ownerName?: string;

  /**
   * @generated from field: string vendor_name = 10;
   */
  vendorName?: string;

  /**
   * draft, active, retired
   *
   * @generated from field: string deployment_status = 11;
   */
  deploymentStatus?: string;

  /**
   * minimal, limited, high, critical, prohibited
   *
   * @generated from field: string risk_class = 12;
   */
  riskClass?: string;

  /**
   * draft, conditioned, approved, blocked, retired
   *
   * @generated from field: string approval_status = 13;
   */
  approvalStatus?: string;

  /**
   * e.g., "2026-07"
   *
   * @generated from field: string template_version = 14;
   */
  templateVersion?: string;

  /**
   * JSONB — evidence control state per system
   *
   * @generated from field: string controls_json = 15;
   */
  controlsJson?: string;

  /**
   * JSONB — flexible metadata
   *
   * @generated from field: string metadata_json = 16;
   */
  metadataJson?: string;

  /**
   * @generated from field: int64 created_at = 17;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 18;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.System.
 * Use `create(SystemSchema)` to create a new message.
 */
export const SystemSchema: GenMessage<System, {jsonType: SystemJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 0);

/**
 * @generated from message guardianai.v1.governableai.ListSystemsRequest
 */
export type ListSystemsRequest = Message<"guardianai.v1.governableai.ListSystemsRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * optional filter by risk class
   *
   * @generated from field: string risk_class_filter = 4;
   */
  riskClassFilter: string;

  /**
   * optional filter by approval status
   *
   * @generated from field: string approval_status_filter = 5;
   */
  approvalStatusFilter: string;
};

/**
 * @generated from message guardianai.v1.governableai.ListSystemsRequest
 */
export type ListSystemsRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken?: string;

  /**
   * optional filter by risk class
   *
   * @generated from field: string risk_class_filter = 4;
   */
  riskClassFilter?: string;

  /**
   * optional filter by approval status
   *
   * @generated from field: string approval_status_filter = 5;
   */
  approvalStatusFilter?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ListSystemsRequest.
 * Use `create(ListSystemsRequestSchema)` to create a new message.
 */
export const ListSystemsRequestSchema: GenMessage<ListSystemsRequest, {jsonType: ListSystemsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 1);

/**
 * @generated from message guardianai.v1.governableai.ListSystemsResponse
 */
export type ListSystemsResponse = Message<"guardianai.v1.governableai.ListSystemsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.governableai.System systems = 1;
   */
  systems: System[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.governableai.ListSystemsResponse
 */
export type ListSystemsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.governableai.System systems = 1;
   */
  systems?: SystemJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.governableai.ListSystemsResponse.
 * Use `create(ListSystemsResponseSchema)` to create a new message.
 */
export const ListSystemsResponseSchema: GenMessage<ListSystemsResponse, {jsonType: ListSystemsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 2);

/**
 * @generated from message guardianai.v1.governableai.GetSystemRequest
 */
export type GetSystemRequest = Message<"guardianai.v1.governableai.GetSystemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;
};

/**
 * @generated from message guardianai.v1.governableai.GetSystemRequest
 */
export type GetSystemRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;
};

/**
 * Describes the message guardianai.v1.governableai.GetSystemRequest.
 * Use `create(GetSystemRequestSchema)` to create a new message.
 */
export const GetSystemRequestSchema: GenMessage<GetSystemRequest, {jsonType: GetSystemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 3);

/**
 * @generated from message guardianai.v1.governableai.CreateSystemRequest
 */
export type CreateSystemRequest = Message<"guardianai.v1.governableai.CreateSystemRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * @generated from field: string created_by = 2;
   */
  createdBy: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string purpose = 4;
   */
  purpose: string;

  /**
   * @generated from field: string business_unit = 5;
   */
  businessUnit: string;

  /**
   * @generated from field: string owner_user_id = 6;
   */
  ownerUserId: string;

  /**
   * @generated from field: string owner_name = 7;
   */
  ownerName: string;

  /**
   * @generated from field: string vendor_name = 8;
   */
  vendorName: string;

  /**
   * @generated from field: string deployment_status = 9;
   */
  deploymentStatus: string;

  /**
   * @generated from field: string risk_class = 10;
   */
  riskClass: string;

  /**
   * @generated from field: string template_version = 11;
   */
  templateVersion: string;
};

/**
 * @generated from message guardianai.v1.governableai.CreateSystemRequest
 */
export type CreateSystemRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;

  /**
   * @generated from field: string created_by = 2;
   */
  createdBy?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string purpose = 4;
   */
  purpose?: string;

  /**
   * @generated from field: string business_unit = 5;
   */
  businessUnit?: string;

  /**
   * @generated from field: string owner_user_id = 6;
   */
  ownerUserId?: string;

  /**
   * @generated from field: string owner_name = 7;
   */
  ownerName?: string;

  /**
   * @generated from field: string vendor_name = 8;
   */
  vendorName?: string;

  /**
   * @generated from field: string deployment_status = 9;
   */
  deploymentStatus?: string;

  /**
   * @generated from field: string risk_class = 10;
   */
  riskClass?: string;

  /**
   * @generated from field: string template_version = 11;
   */
  templateVersion?: string;
};

/**
 * Describes the message guardianai.v1.governableai.CreateSystemRequest.
 * Use `create(CreateSystemRequestSchema)` to create a new message.
 */
export const CreateSystemRequestSchema: GenMessage<CreateSystemRequest, {jsonType: CreateSystemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 4);

/**
 * @generated from message guardianai.v1.governableai.UpdateSystemRequest
 */
export type UpdateSystemRequest = Message<"guardianai.v1.governableai.UpdateSystemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string purpose = 5;
   */
  purpose: string;

  /**
   * @generated from field: string business_unit = 6;
   */
  businessUnit: string;

  /**
   * @generated from field: string owner_user_id = 7;
   */
  ownerUserId: string;

  /**
   * @generated from field: string owner_name = 8;
   */
  ownerName: string;

  /**
   * @generated from field: string vendor_name = 9;
   */
  vendorName: string;

  /**
   * @generated from field: string deployment_status = 10;
   */
  deploymentStatus: string;

  /**
   * @generated from field: string risk_class = 11;
   */
  riskClass: string;

  /**
   * @generated from field: string approval_status = 12;
   */
  approvalStatus: string;

  /**
   * @generated from field: string controls_json = 13;
   */
  controlsJson: string;

  /**
   * @generated from field: string metadata_json = 14;
   */
  metadataJson: string;
};

/**
 * @generated from message guardianai.v1.governableai.UpdateSystemRequest
 */
export type UpdateSystemRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;

  /**
   * @generated from field: string name = 4;
   */
  name?: string;

  /**
   * @generated from field: string purpose = 5;
   */
  purpose?: string;

  /**
   * @generated from field: string business_unit = 6;
   */
  businessUnit?: string;

  /**
   * @generated from field: string owner_user_id = 7;
   */
  ownerUserId?: string;

  /**
   * @generated from field: string owner_name = 8;
   */
  ownerName?: string;

  /**
   * @generated from field: string vendor_name = 9;
   */
  vendorName?: string;

  /**
   * @generated from field: string deployment_status = 10;
   */
  deploymentStatus?: string;

  /**
   * @generated from field: string risk_class = 11;
   */
  riskClass?: string;

  /**
   * @generated from field: string approval_status = 12;
   */
  approvalStatus?: string;

  /**
   * @generated from field: string controls_json = 13;
   */
  controlsJson?: string;

  /**
   * @generated from field: string metadata_json = 14;
   */
  metadataJson?: string;
};

/**
 * Describes the message guardianai.v1.governableai.UpdateSystemRequest.
 * Use `create(UpdateSystemRequestSchema)` to create a new message.
 */
export const UpdateSystemRequestSchema: GenMessage<UpdateSystemRequest, {jsonType: UpdateSystemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 5);

/**
 * @generated from message guardianai.v1.governableai.DeleteSystemRequest
 */
export type DeleteSystemRequest = Message<"guardianai.v1.governableai.DeleteSystemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;
};

/**
 * @generated from message guardianai.v1.governableai.DeleteSystemRequest
 */
export type DeleteSystemRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;
};

/**
 * Describes the message guardianai.v1.governableai.DeleteSystemRequest.
 * Use `create(DeleteSystemRequestSchema)` to create a new message.
 */
export const DeleteSystemRequestSchema: GenMessage<DeleteSystemRequest, {jsonType: DeleteSystemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 6);

/**
 * @generated from message guardianai.v1.governableai.DeleteSystemResponse
 */
export type DeleteSystemResponse = Message<"guardianai.v1.governableai.DeleteSystemResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.governableai.DeleteSystemResponse
 */
export type DeleteSystemResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.governableai.DeleteSystemResponse.
 * Use `create(DeleteSystemResponseSchema)` to create a new message.
 */
export const DeleteSystemResponseSchema: GenMessage<DeleteSystemResponse, {jsonType: DeleteSystemResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 7);

/**
 * @generated from message guardianai.v1.governableai.EvidenceItem
 */
export type EvidenceItem = Message<"guardianai.v1.governableai.EvidenceItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * link, file, manual
   *
   * @generated from field: string source_type = 5;
   */
  sourceType: string;

  /**
   * @generated from field: string owner_user_id = 6;
   */
  ownerUserId: string;

  /**
   * missing, requested, partial, ready, verified, expired
   *
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * unreviewed, adequate, high
   *
   * @generated from field: string quality_rating = 8;
   */
  qualityRating: string;

  /**
   * @generated from field: string link_or_file_id = 9;
   */
  linkOrFileId: string;

  /**
   * @generated from field: string notes = 10;
   */
  notes: string;

  /**
   * @generated from field: int64 created_at = 11;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 12;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.EvidenceItem
 */
export type EvidenceItemJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: string title = 4;
   */
  title?: string;

  /**
   * link, file, manual
   *
   * @generated from field: string source_type = 5;
   */
  sourceType?: string;

  /**
   * @generated from field: string owner_user_id = 6;
   */
  ownerUserId?: string;

  /**
   * missing, requested, partial, ready, verified, expired
   *
   * @generated from field: string status = 7;
   */
  status?: string;

  /**
   * unreviewed, adequate, high
   *
   * @generated from field: string quality_rating = 8;
   */
  qualityRating?: string;

  /**
   * @generated from field: string link_or_file_id = 9;
   */
  linkOrFileId?: string;

  /**
   * @generated from field: string notes = 10;
   */
  notes?: string;

  /**
   * @generated from field: int64 created_at = 11;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 12;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.EvidenceItem.
 * Use `create(EvidenceItemSchema)` to create a new message.
 */
export const EvidenceItemSchema: GenMessage<EvidenceItem, {jsonType: EvidenceItemJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 8);

/**
 * @generated from message guardianai.v1.governableai.ListEvidenceItemsRequest
 */
export type ListEvidenceItemsRequest = Message<"guardianai.v1.governableai.ListEvidenceItemsRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;
};

/**
 * @generated from message guardianai.v1.governableai.ListEvidenceItemsRequest
 */
export type ListEvidenceItemsRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ListEvidenceItemsRequest.
 * Use `create(ListEvidenceItemsRequestSchema)` to create a new message.
 */
export const ListEvidenceItemsRequestSchema: GenMessage<ListEvidenceItemsRequest, {jsonType: ListEvidenceItemsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 9);

/**
 * @generated from message guardianai.v1.governableai.ListEvidenceItemsResponse
 */
export type ListEvidenceItemsResponse = Message<"guardianai.v1.governableai.ListEvidenceItemsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.governableai.EvidenceItem items = 1;
   */
  items: EvidenceItem[];
};

/**
 * @generated from message guardianai.v1.governableai.ListEvidenceItemsResponse
 */
export type ListEvidenceItemsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.governableai.EvidenceItem items = 1;
   */
  items?: EvidenceItemJson[];
};

/**
 * Describes the message guardianai.v1.governableai.ListEvidenceItemsResponse.
 * Use `create(ListEvidenceItemsResponseSchema)` to create a new message.
 */
export const ListEvidenceItemsResponseSchema: GenMessage<ListEvidenceItemsResponse, {jsonType: ListEvidenceItemsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 10);

/**
 * @generated from message guardianai.v1.governableai.UpdateEvidenceItemRequest
 */
export type UpdateEvidenceItemRequest = Message<"guardianai.v1.governableai.UpdateEvidenceItemRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string quality_rating = 6;
   */
  qualityRating: string;

  /**
   * @generated from field: string link_or_file_id = 7;
   */
  linkOrFileId: string;

  /**
   * @generated from field: string notes = 8;
   */
  notes: string;

  /**
   * @generated from field: string source_type = 9;
   */
  sourceType: string;
};

/**
 * @generated from message guardianai.v1.governableai.UpdateEvidenceItemRequest
 */
export type UpdateEvidenceItemRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId?: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: string quality_rating = 6;
   */
  qualityRating?: string;

  /**
   * @generated from field: string link_or_file_id = 7;
   */
  linkOrFileId?: string;

  /**
   * @generated from field: string notes = 8;
   */
  notes?: string;

  /**
   * @generated from field: string source_type = 9;
   */
  sourceType?: string;
};

/**
 * Describes the message guardianai.v1.governableai.UpdateEvidenceItemRequest.
 * Use `create(UpdateEvidenceItemRequestSchema)` to create a new message.
 */
export const UpdateEvidenceItemRequestSchema: GenMessage<UpdateEvidenceItemRequest, {jsonType: UpdateEvidenceItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 11);

/**
 * @generated from message guardianai.v1.governableai.BatchUpdateEvidenceItemsRequest
 */
export type BatchUpdateEvidenceItemsRequest = Message<"guardianai.v1.governableai.BatchUpdateEvidenceItemsRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;

  /**
   * apply this status to all matching IDs
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * items to update; at least one ID is required
   *
   * @generated from field: repeated string item_ids = 5;
   */
  itemIds: string[];
};

/**
 * @generated from message guardianai.v1.governableai.BatchUpdateEvidenceItemsRequest
 */
export type BatchUpdateEvidenceItemsRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;

  /**
   * apply this status to all matching IDs
   *
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * items to update; at least one ID is required
   *
   * @generated from field: repeated string item_ids = 5;
   */
  itemIds?: string[];
};

/**
 * Describes the message guardianai.v1.governableai.BatchUpdateEvidenceItemsRequest.
 * Use `create(BatchUpdateEvidenceItemsRequestSchema)` to create a new message.
 */
export const BatchUpdateEvidenceItemsRequestSchema: GenMessage<BatchUpdateEvidenceItemsRequest, {jsonType: BatchUpdateEvidenceItemsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 12);

/**
 * @generated from message guardianai.v1.governableai.BatchUpdateEvidenceItemsResponse
 */
export type BatchUpdateEvidenceItemsResponse = Message<"guardianai.v1.governableai.BatchUpdateEvidenceItemsResponse"> & {
  /**
   * @generated from field: int32 updated_count = 1;
   */
  updatedCount: number;

  /**
   * @generated from field: repeated guardianai.v1.governableai.EvidenceItem items = 2;
   */
  items: EvidenceItem[];
};

/**
 * @generated from message guardianai.v1.governableai.BatchUpdateEvidenceItemsResponse
 */
export type BatchUpdateEvidenceItemsResponseJson = {
  /**
   * @generated from field: int32 updated_count = 1;
   */
  updatedCount?: number;

  /**
   * @generated from field: repeated guardianai.v1.governableai.EvidenceItem items = 2;
   */
  items?: EvidenceItemJson[];
};

/**
 * Describes the message guardianai.v1.governableai.BatchUpdateEvidenceItemsResponse.
 * Use `create(BatchUpdateEvidenceItemsResponseSchema)` to create a new message.
 */
export const BatchUpdateEvidenceItemsResponseSchema: GenMessage<BatchUpdateEvidenceItemsResponse, {jsonType: BatchUpdateEvidenceItemsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 13);

/**
 * @generated from message guardianai.v1.governableai.ApprovalGate
 */
export type ApprovalGate = Message<"guardianai.v1.governableai.ApprovalGate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * draft, conditioned, approved, blocked, expired, revoked
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string approver_user_id = 4;
   */
  approverUserId: string;

  /**
   * JSON array of conditions
   *
   * @generated from field: string conditions_json = 5;
   */
  conditionsJson: string;

  /**
   * @generated from field: string blocked_reason = 6;
   */
  blockedReason: string;

  /**
   * @generated from field: int64 approved_at = 7;
   */
  approvedAt: bigint;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt: bigint;

  /**
   * @generated from field: string reapproval_trigger = 9;
   */
  reapprovalTrigger: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 11;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.ApprovalGate
 */
export type ApprovalGateJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * draft, conditioned, approved, blocked, expired, revoked
   *
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: string approver_user_id = 4;
   */
  approverUserId?: string;

  /**
   * JSON array of conditions
   *
   * @generated from field: string conditions_json = 5;
   */
  conditionsJson?: string;

  /**
   * @generated from field: string blocked_reason = 6;
   */
  blockedReason?: string;

  /**
   * @generated from field: int64 approved_at = 7;
   */
  approvedAt?: string;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt?: string;

  /**
   * @generated from field: string reapproval_trigger = 9;
   */
  reapprovalTrigger?: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 11;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ApprovalGate.
 * Use `create(ApprovalGateSchema)` to create a new message.
 */
export const ApprovalGateSchema: GenMessage<ApprovalGate, {jsonType: ApprovalGateJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 14);

/**
 * @generated from message guardianai.v1.governableai.GetApprovalGateRequest
 */
export type GetApprovalGateRequest = Message<"guardianai.v1.governableai.GetApprovalGateRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;
};

/**
 * @generated from message guardianai.v1.governableai.GetApprovalGateRequest
 */
export type GetApprovalGateRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;
};

/**
 * Describes the message guardianai.v1.governableai.GetApprovalGateRequest.
 * Use `create(GetApprovalGateRequestSchema)` to create a new message.
 */
export const GetApprovalGateRequestSchema: GenMessage<GetApprovalGateRequest, {jsonType: GetApprovalGateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 15);

/**
 * @generated from message guardianai.v1.governableai.UpsertApprovalGateRequest
 */
export type UpsertApprovalGateRequest = Message<"guardianai.v1.governableai.UpsertApprovalGateRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string approver_user_id = 5;
   */
  approverUserId: string;

  /**
   * @generated from field: string conditions_json = 6;
   */
  conditionsJson: string;

  /**
   * @generated from field: string blocked_reason = 7;
   */
  blockedReason: string;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt: bigint;

  /**
   * @generated from field: string reapproval_trigger = 9;
   */
  reapprovalTrigger: string;
};

/**
 * @generated from message guardianai.v1.governableai.UpsertApprovalGateRequest
 */
export type UpsertApprovalGateRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string approver_user_id = 5;
   */
  approverUserId?: string;

  /**
   * @generated from field: string conditions_json = 6;
   */
  conditionsJson?: string;

  /**
   * @generated from field: string blocked_reason = 7;
   */
  blockedReason?: string;

  /**
   * @generated from field: int64 expires_at = 8;
   */
  expiresAt?: string;

  /**
   * @generated from field: string reapproval_trigger = 9;
   */
  reapprovalTrigger?: string;
};

/**
 * Describes the message guardianai.v1.governableai.UpsertApprovalGateRequest.
 * Use `create(UpsertApprovalGateRequestSchema)` to create a new message.
 */
export const UpsertApprovalGateRequestSchema: GenMessage<UpsertApprovalGateRequest, {jsonType: UpsertApprovalGateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 16);

/**
 * @generated from message guardianai.v1.governableai.RedressCase
 */
export type RedressCase = Message<"guardianai.v1.governableai.RedressCase"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * @generated from field: string incident_id = 3;
   */
  incidentId: string;

  /**
   * @generated from field: string affected_person_reference = 4;
   */
  affectedPersonReference: string;

  /**
   * internal, external, regulatory
   *
   * @generated from field: string channel = 5;
   */
  channel: string;

  /**
   * open, reviewing, corrected, rejected, closed, systemic_review
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int64 received_at = 7;
   */
  receivedAt: bigint;

  /**
   * @generated from field: int64 due_at = 8;
   */
  dueAt: bigint;

  /**
   * @generated from field: string reviewer_user_id = 9;
   */
  reviewerUserId: string;

  /**
   * @generated from field: string summary = 10;
   */
  summary: string;

  /**
   * @generated from field: string requested_remedy = 11;
   */
  requestedRemedy: string;

  /**
   * @generated from field: string outcome = 12;
   */
  outcome: string;

  /**
   * @generated from field: string outcome_reason = 13;
   */
  outcomeReason: string;

  /**
   * @generated from field: int64 closed_at = 14;
   */
  closedAt: bigint;

  /**
   * @generated from field: int64 created_at = 15;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 16;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.RedressCase
 */
export type RedressCaseJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string incident_id = 3;
   */
  incidentId?: string;

  /**
   * @generated from field: string affected_person_reference = 4;
   */
  affectedPersonReference?: string;

  /**
   * internal, external, regulatory
   *
   * @generated from field: string channel = 5;
   */
  channel?: string;

  /**
   * open, reviewing, corrected, rejected, closed, systemic_review
   *
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * @generated from field: int64 received_at = 7;
   */
  receivedAt?: string;

  /**
   * @generated from field: int64 due_at = 8;
   */
  dueAt?: string;

  /**
   * @generated from field: string reviewer_user_id = 9;
   */
  reviewerUserId?: string;

  /**
   * @generated from field: string summary = 10;
   */
  summary?: string;

  /**
   * @generated from field: string requested_remedy = 11;
   */
  requestedRemedy?: string;

  /**
   * @generated from field: string outcome = 12;
   */
  outcome?: string;

  /**
   * @generated from field: string outcome_reason = 13;
   */
  outcomeReason?: string;

  /**
   * @generated from field: int64 closed_at = 14;
   */
  closedAt?: string;

  /**
   * @generated from field: int64 created_at = 15;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 16;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.RedressCase.
 * Use `create(RedressCaseSchema)` to create a new message.
 */
export const RedressCaseSchema: GenMessage<RedressCase, {jsonType: RedressCaseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 17);

/**
 * @generated from message guardianai.v1.governableai.ListRedressCasesRequest
 */
export type ListRedressCasesRequest = Message<"guardianai.v1.governableai.ListRedressCasesRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * optional filter
   *
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;
};

/**
 * @generated from message guardianai.v1.governableai.ListRedressCasesRequest
 */
export type ListRedressCasesRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * optional filter
   *
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ListRedressCasesRequest.
 * Use `create(ListRedressCasesRequestSchema)` to create a new message.
 */
export const ListRedressCasesRequestSchema: GenMessage<ListRedressCasesRequest, {jsonType: ListRedressCasesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 18);

/**
 * @generated from message guardianai.v1.governableai.ListRedressCasesResponse
 */
export type ListRedressCasesResponse = Message<"guardianai.v1.governableai.ListRedressCasesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.governableai.RedressCase cases = 1;
   */
  cases: RedressCase[];
};

/**
 * @generated from message guardianai.v1.governableai.ListRedressCasesResponse
 */
export type ListRedressCasesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.governableai.RedressCase cases = 1;
   */
  cases?: RedressCaseJson[];
};

/**
 * Describes the message guardianai.v1.governableai.ListRedressCasesResponse.
 * Use `create(ListRedressCasesResponseSchema)` to create a new message.
 */
export const ListRedressCasesResponseSchema: GenMessage<ListRedressCasesResponse, {jsonType: ListRedressCasesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 19);

/**
 * @generated from message guardianai.v1.governableai.CreateRedressCaseRequest
 */
export type CreateRedressCaseRequest = Message<"guardianai.v1.governableai.CreateRedressCaseRequest"> & {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string created_by = 3;
   */
  createdBy: string;

  /**
   * @generated from field: string incident_id = 4;
   */
  incidentId: string;

  /**
   * @generated from field: string affected_person_reference = 5;
   */
  affectedPersonReference: string;

  /**
   * @generated from field: string channel = 6;
   */
  channel: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: int64 due_at = 8;
   */
  dueAt: bigint;

  /**
   * @generated from field: string summary = 9;
   */
  summary: string;

  /**
   * @generated from field: string requested_remedy = 10;
   */
  requestedRemedy: string;
};

/**
 * @generated from message guardianai.v1.governableai.CreateRedressCaseRequest
 */
export type CreateRedressCaseRequestJson = {
  /**
   * @generated from field: string ai_system_id = 1;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string created_by = 3;
   */
  createdBy?: string;

  /**
   * @generated from field: string incident_id = 4;
   */
  incidentId?: string;

  /**
   * @generated from field: string affected_person_reference = 5;
   */
  affectedPersonReference?: string;

  /**
   * @generated from field: string channel = 6;
   */
  channel?: string;

  /**
   * @generated from field: string status = 7;
   */
  status?: string;

  /**
   * @generated from field: int64 due_at = 8;
   */
  dueAt?: string;

  /**
   * @generated from field: string summary = 9;
   */
  summary?: string;

  /**
   * @generated from field: string requested_remedy = 10;
   */
  requestedRemedy?: string;
};

/**
 * Describes the message guardianai.v1.governableai.CreateRedressCaseRequest.
 * Use `create(CreateRedressCaseRequestSchema)` to create a new message.
 */
export const CreateRedressCaseRequestSchema: GenMessage<CreateRedressCaseRequest, {jsonType: CreateRedressCaseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 20);

/**
 * @generated from message guardianai.v1.governableai.UpdateRedressCaseRequest
 */
export type UpdateRedressCaseRequest = Message<"guardianai.v1.governableai.UpdateRedressCaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string reviewer_user_id = 6;
   */
  reviewerUserId: string;

  /**
   * @generated from field: string summary = 7;
   */
  summary: string;

  /**
   * @generated from field: string requested_remedy = 8;
   */
  requestedRemedy: string;

  /**
   * @generated from field: string outcome = 9;
   */
  outcome: string;

  /**
   * @generated from field: string outcome_reason = 10;
   */
  outcomeReason: string;

  /**
   * @generated from field: int64 closed_at = 11;
   */
  closedAt: bigint;

  /**
   * @generated from field: int64 due_at = 12;
   */
  dueAt: bigint;

  /**
   * @generated from field: string affected_person_reference = 13;
   */
  affectedPersonReference: string;

  /**
   * @generated from field: string channel = 14;
   */
  channel: string;
};

/**
 * @generated from message guardianai.v1.governableai.UpdateRedressCaseRequest
 */
export type UpdateRedressCaseRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId?: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: string reviewer_user_id = 6;
   */
  reviewerUserId?: string;

  /**
   * @generated from field: string summary = 7;
   */
  summary?: string;

  /**
   * @generated from field: string requested_remedy = 8;
   */
  requestedRemedy?: string;

  /**
   * @generated from field: string outcome = 9;
   */
  outcome?: string;

  /**
   * @generated from field: string outcome_reason = 10;
   */
  outcomeReason?: string;

  /**
   * @generated from field: int64 closed_at = 11;
   */
  closedAt?: string;

  /**
   * @generated from field: int64 due_at = 12;
   */
  dueAt?: string;

  /**
   * @generated from field: string affected_person_reference = 13;
   */
  affectedPersonReference?: string;

  /**
   * @generated from field: string channel = 14;
   */
  channel?: string;
};

/**
 * Describes the message guardianai.v1.governableai.UpdateRedressCaseRequest.
 * Use `create(UpdateRedressCaseRequestSchema)` to create a new message.
 */
export const UpdateRedressCaseRequestSchema: GenMessage<UpdateRedressCaseRequest, {jsonType: UpdateRedressCaseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 21);

/**
 * @generated from message guardianai.v1.governableai.Export
 */
export type Export = Message<"guardianai.v1.governableai.Export"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string ai_system_id = 3;
   */
  aiSystemId: string;

  /**
   * system-card, board-summary, audit-starter-pack
   *
   * @generated from field: string export_type = 4;
   */
  exportType: string;

  /**
   * json, pdf, csv
   *
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: string template_version = 6;
   */
  templateVersion: string;

  /**
   * @generated from field: string requested_by = 7;
   */
  requestedBy: string;

  /**
   * @generated from field: string file_id = 8;
   */
  fileId: string;

  /**
   * JSONB — export metadata
   *
   * @generated from field: string metadata_json = 9;
   */
  metadataJson: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.Export
 */
export type ExportJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string ai_system_id = 3;
   */
  aiSystemId?: string;

  /**
   * system-card, board-summary, audit-starter-pack
   *
   * @generated from field: string export_type = 4;
   */
  exportType?: string;

  /**
   * json, pdf, csv
   *
   * @generated from field: string format = 5;
   */
  format?: string;

  /**
   * @generated from field: string template_version = 6;
   */
  templateVersion?: string;

  /**
   * @generated from field: string requested_by = 7;
   */
  requestedBy?: string;

  /**
   * @generated from field: string file_id = 8;
   */
  fileId?: string;

  /**
   * JSONB — export metadata
   *
   * @generated from field: string metadata_json = 9;
   */
  metadataJson?: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.Export.
 * Use `create(ExportSchema)` to create a new message.
 */
export const ExportSchema: GenMessage<Export, {jsonType: ExportJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 22);

/**
 * @generated from message guardianai.v1.governableai.CreateExportRequest
 */
export type CreateExportRequest = Message<"guardianai.v1.governableai.CreateExportRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * @generated from field: string requested_by = 3;
   */
  requestedBy: string;

  /**
   * @generated from field: string export_type = 4;
   */
  exportType: string;

  /**
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: string template_version = 6;
   */
  templateVersion: string;

  /**
   * @generated from field: string metadata_json = 7;
   */
  metadataJson: string;
};

/**
 * @generated from message guardianai.v1.governableai.CreateExportRequest
 */
export type CreateExportRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;

  /**
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * @generated from field: string requested_by = 3;
   */
  requestedBy?: string;

  /**
   * @generated from field: string export_type = 4;
   */
  exportType?: string;

  /**
   * @generated from field: string format = 5;
   */
  format?: string;

  /**
   * @generated from field: string template_version = 6;
   */
  templateVersion?: string;

  /**
   * @generated from field: string metadata_json = 7;
   */
  metadataJson?: string;
};

/**
 * Describes the message guardianai.v1.governableai.CreateExportRequest.
 * Use `create(CreateExportRequestSchema)` to create a new message.
 */
export const CreateExportRequestSchema: GenMessage<CreateExportRequest, {jsonType: CreateExportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 23);

/**
 * @generated from message guardianai.v1.governableai.ListExportsRequest
 */
export type ListExportsRequest = Message<"guardianai.v1.governableai.ListExportsRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * optional; filter by system
   *
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId: string;

  /**
   * optional; filter by type
   *
   * @generated from field: string export_type = 3;
   */
  exportType: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.governableai.ListExportsRequest
 */
export type ListExportsRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;

  /**
   * optional; filter by system
   *
   * @generated from field: string ai_system_id = 2;
   */
  aiSystemId?: string;

  /**
   * optional; filter by type
   *
   * @generated from field: string export_type = 3;
   */
  exportType?: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ListExportsRequest.
 * Use `create(ListExportsRequestSchema)` to create a new message.
 */
export const ListExportsRequestSchema: GenMessage<ListExportsRequest, {jsonType: ListExportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 24);

/**
 * @generated from message guardianai.v1.governableai.ListExportsResponse
 */
export type ListExportsResponse = Message<"guardianai.v1.governableai.ListExportsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.governableai.Export exports = 1;
   */
  exports: Export[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.governableai.ListExportsResponse
 */
export type ListExportsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.governableai.Export exports = 1;
   */
  exports?: ExportJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.governableai.ListExportsResponse.
 * Use `create(ListExportsResponseSchema)` to create a new message.
 */
export const ListExportsResponseSchema: GenMessage<ListExportsResponse, {jsonType: ListExportsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 25);

/**
 * @generated from message guardianai.v1.governableai.ActivityLogEntry
 */
export type ActivityLogEntry = Message<"guardianai.v1.governableai.ActivityLogEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string actor_user_id = 3;
   */
  actorUserId: string;

  /**
   * system, evidence, approval, redress, export
   *
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 5;
   */
  entityId: string;

  /**
   * created, updated, deleted, exported, approved, etc.
   *
   * @generated from field: string action = 6;
   */
  action: string;

  /**
   * @generated from field: string metadata_json = 7;
   */
  metadataJson: string;

  /**
   * @generated from field: int64 created_at = 8;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.governableai.ActivityLogEntry
 */
export type ActivityLogEntryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * @generated from field: string actor_user_id = 3;
   */
  actorUserId?: string;

  /**
   * system, evidence, approval, redress, export
   *
   * @generated from field: string entity_type = 4;
   */
  entityType?: string;

  /**
   * @generated from field: string entity_id = 5;
   */
  entityId?: string;

  /**
   * created, updated, deleted, exported, approved, etc.
   *
   * @generated from field: string action = 6;
   */
  action?: string;

  /**
   * @generated from field: string metadata_json = 7;
   */
  metadataJson?: string;

  /**
   * @generated from field: int64 created_at = 8;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ActivityLogEntry.
 * Use `create(ActivityLogEntrySchema)` to create a new message.
 */
export const ActivityLogEntrySchema: GenMessage<ActivityLogEntry, {jsonType: ActivityLogEntryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 26);

/**
 * @generated from message guardianai.v1.governableai.ListActivityLogRequest
 */
export type ListActivityLogRequest = Message<"guardianai.v1.governableai.ListActivityLogRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * optional filter
   *
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * optional filter
   *
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * optional filter
   *
   * @generated from field: string actor_user_id = 4;
   */
  actorUserId: string;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.governableai.ListActivityLogRequest
 */
export type ListActivityLogRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;

  /**
   * optional filter
   *
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * optional filter
   *
   * @generated from field: string entity_id = 3;
   */
  entityId?: string;

  /**
   * optional filter
   *
   * @generated from field: string actor_user_id = 4;
   */
  actorUserId?: string;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.governableai.ListActivityLogRequest.
 * Use `create(ListActivityLogRequestSchema)` to create a new message.
 */
export const ListActivityLogRequestSchema: GenMessage<ListActivityLogRequest, {jsonType: ListActivityLogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 27);

/**
 * @generated from message guardianai.v1.governableai.ListActivityLogResponse
 */
export type ListActivityLogResponse = Message<"guardianai.v1.governableai.ListActivityLogResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.governableai.ActivityLogEntry entries = 1;
   */
  entries: ActivityLogEntry[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.governableai.ListActivityLogResponse
 */
export type ListActivityLogResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.governableai.ActivityLogEntry entries = 1;
   */
  entries?: ActivityLogEntryJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.governableai.ListActivityLogResponse.
 * Use `create(ListActivityLogResponseSchema)` to create a new message.
 */
export const ListActivityLogResponseSchema: GenMessage<ListActivityLogResponse, {jsonType: ListActivityLogResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 28);

/**
 * @generated from message guardianai.v1.governableai.WorkspaceUsage
 */
export type WorkspaceUsage = Message<"guardianai.v1.governableai.WorkspaceUsage"> & {
  /**
   * Current usage counts
   *
   * @generated from field: int32 ai_system_count = 1;
   */
  aiSystemCount: number;

  /**
   * @generated from field: int32 member_count = 2;
   */
  memberCount: number;

  /**
   * @generated from field: int32 exports_this_month = 3;
   */
  exportsThisMonth: number;

  /**
   * @generated from field: int64 evidence_storage_bytes = 4;
   */
  evidenceStorageBytes: bigint;

  /**
   * Subscription plan limits
   *
   * @generated from field: int32 ai_system_limit = 5;
   */
  aiSystemLimit: number;

  /**
   * @generated from field: int32 member_limit = 6;
   */
  memberLimit: number;

  /**
   * @generated from field: int32 export_limit_per_month = 7;
   */
  exportLimitPerMonth: number;

  /**
   * @generated from field: int64 evidence_storage_gb = 8;
   */
  evidenceStorageGb: bigint;

  /**
   * Feature flags from subscription quotas
   *
   * @generated from field: bool approval_gates_enabled = 9;
   */
  approvalGatesEnabled: boolean;

  /**
   * @generated from field: bool redress_workflows_enabled = 10;
   */
  redressWorkflowsEnabled: boolean;

  /**
   * @generated from field: bool board_exports_enabled = 11;
   */
  boardExportsEnabled: boolean;

  /**
   * @generated from field: bool template_versioning_enabled = 12;
   */
  templateVersioningEnabled: boolean;
};

/**
 * @generated from message guardianai.v1.governableai.WorkspaceUsage
 */
export type WorkspaceUsageJson = {
  /**
   * Current usage counts
   *
   * @generated from field: int32 ai_system_count = 1;
   */
  aiSystemCount?: number;

  /**
   * @generated from field: int32 member_count = 2;
   */
  memberCount?: number;

  /**
   * @generated from field: int32 exports_this_month = 3;
   */
  exportsThisMonth?: number;

  /**
   * @generated from field: int64 evidence_storage_bytes = 4;
   */
  evidenceStorageBytes?: string;

  /**
   * Subscription plan limits
   *
   * @generated from field: int32 ai_system_limit = 5;
   */
  aiSystemLimit?: number;

  /**
   * @generated from field: int32 member_limit = 6;
   */
  memberLimit?: number;

  /**
   * @generated from field: int32 export_limit_per_month = 7;
   */
  exportLimitPerMonth?: number;

  /**
   * @generated from field: int64 evidence_storage_gb = 8;
   */
  evidenceStorageGb?: string;

  /**
   * Feature flags from subscription quotas
   *
   * @generated from field: bool approval_gates_enabled = 9;
   */
  approvalGatesEnabled?: boolean;

  /**
   * @generated from field: bool redress_workflows_enabled = 10;
   */
  redressWorkflowsEnabled?: boolean;

  /**
   * @generated from field: bool board_exports_enabled = 11;
   */
  boardExportsEnabled?: boolean;

  /**
   * @generated from field: bool template_versioning_enabled = 12;
   */
  templateVersioningEnabled?: boolean;
};

/**
 * Describes the message guardianai.v1.governableai.WorkspaceUsage.
 * Use `create(WorkspaceUsageSchema)` to create a new message.
 */
export const WorkspaceUsageSchema: GenMessage<WorkspaceUsage, {jsonType: WorkspaceUsageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 29);

/**
 * @generated from message guardianai.v1.governableai.GetWorkspaceUsageRequest
 */
export type GetWorkspaceUsageRequest = Message<"guardianai.v1.governableai.GetWorkspaceUsageRequest"> & {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;
};

/**
 * @generated from message guardianai.v1.governableai.GetWorkspaceUsageRequest
 */
export type GetWorkspaceUsageRequestJson = {
  /**
   * @generated from field: string tenant_id = 1;
   */
  tenantId?: string;
};

/**
 * Describes the message guardianai.v1.governableai.GetWorkspaceUsageRequest.
 * Use `create(GetWorkspaceUsageRequestSchema)` to create a new message.
 */
export const GetWorkspaceUsageRequestSchema: GenMessage<GetWorkspaceUsageRequest, {jsonType: GetWorkspaceUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_governableai_governable_ai, 30);

/**
 * --------------------------------------------------------------------------
 * AI Systems
 * --------------------------------------------------------------------------
 *
 * @generated from service guardianai.v1.governableai.GovernableAiWorkspaceService
 */
export const GovernableAiWorkspaceService: GenService<{
  /**
   * List all AI systems for the current tenant
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.ListSystems
   */
  listSystems: {
    methodKind: "unary";
    input: typeof ListSystemsRequestSchema;
    output: typeof ListSystemsResponseSchema;
  },
  /**
   * Get a single AI system by ID
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.GetSystem
   */
  getSystem: {
    methodKind: "unary";
    input: typeof GetSystemRequestSchema;
    output: typeof SystemSchema;
  },
  /**
   * Create a new AI system record
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.CreateSystem
   */
  createSystem: {
    methodKind: "unary";
    input: typeof CreateSystemRequestSchema;
    output: typeof SystemSchema;
  },
  /**
   * Update an existing AI system record
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.UpdateSystem
   */
  updateSystem: {
    methodKind: "unary";
    input: typeof UpdateSystemRequestSchema;
    output: typeof SystemSchema;
  },
  /**
   * Delete an AI system record
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.DeleteSystem
   */
  deleteSystem: {
    methodKind: "unary";
    input: typeof DeleteSystemRequestSchema;
    output: typeof DeleteSystemResponseSchema;
  },
  /**
   * List evidence items for a given AI system
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.ListEvidenceItems
   */
  listEvidenceItems: {
    methodKind: "unary";
    input: typeof ListEvidenceItemsRequestSchema;
    output: typeof ListEvidenceItemsResponseSchema;
  },
  /**
   * Update a single evidence item (status, notes, link, quality rating)
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.UpdateEvidenceItem
   */
  updateEvidenceItem: {
    methodKind: "unary";
    input: typeof UpdateEvidenceItemRequestSchema;
    output: typeof EvidenceItemSchema;
  },
  /**
   * Batch update evidence items (e.g., mark all as verified)
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.BatchUpdateEvidenceItems
   */
  batchUpdateEvidenceItems: {
    methodKind: "unary";
    input: typeof BatchUpdateEvidenceItemsRequestSchema;
    output: typeof BatchUpdateEvidenceItemsResponseSchema;
  },
  /**
   * Get the approval gate for a given AI system
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.GetApprovalGate
   */
  getApprovalGate: {
    methodKind: "unary";
    input: typeof GetApprovalGateRequestSchema;
    output: typeof ApprovalGateSchema;
  },
  /**
   * Create or update the approval gate for a given AI system
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.UpsertApprovalGate
   */
  upsertApprovalGate: {
    methodKind: "unary";
    input: typeof UpsertApprovalGateRequestSchema;
    output: typeof ApprovalGateSchema;
  },
  /**
   * List redress cases for a given AI system
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.ListRedressCases
   */
  listRedressCases: {
    methodKind: "unary";
    input: typeof ListRedressCasesRequestSchema;
    output: typeof ListRedressCasesResponseSchema;
  },
  /**
   * Create a new redress case
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.CreateRedressCase
   */
  createRedressCase: {
    methodKind: "unary";
    input: typeof CreateRedressCaseRequestSchema;
    output: typeof RedressCaseSchema;
  },
  /**
   * Update an existing redress case
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.UpdateRedressCase
   */
  updateRedressCase: {
    methodKind: "unary";
    input: typeof UpdateRedressCaseRequestSchema;
    output: typeof RedressCaseSchema;
  },
  /**
   * Generate and store an export (system card, board summary, audit pack)
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.CreateExport
   */
  createExport: {
    methodKind: "unary";
    input: typeof CreateExportRequestSchema;
    output: typeof ExportSchema;
  },
  /**
   * List exports for the current tenant
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.ListExports
   */
  listExports: {
    methodKind: "unary";
    input: typeof ListExportsRequestSchema;
    output: typeof ListExportsResponseSchema;
  },
  /**
   * List activity log entries for the current tenant
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.ListActivityLog
   */
  listActivityLog: {
    methodKind: "unary";
    input: typeof ListActivityLogRequestSchema;
    output: typeof ListActivityLogResponseSchema;
  },
  /**
   * Get current workspace usage and quota limits for the subscribed tenant
   *
   * @generated from rpc guardianai.v1.governableai.GovernableAiWorkspaceService.GetWorkspaceUsage
   */
  getWorkspaceUsage: {
    methodKind: "unary";
    input: typeof GetWorkspaceUsageRequestSchema;
    output: typeof WorkspaceUsageSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_governableai_governable_ai, 0);

